export default __webpack_public_path__ + "static/media/school.364b12be.png";